import * as types from './constants';

// Get Analytics Users
export const getDiscoverRequest = data => (
  { type: types.GET_DISCOVER_REQUEST, payload: data }
);

export const getDiscoverDone = data => (
  { type: types.GET_DISCOVER_DONE, payload: data }
);

export const getDiscoverFailed = errors => (
  { type: types.GET_DISCOVER_FAILED, payload: errors }
);

export const getDiscoverReset = () => (
  { type: types.GET_DISCOVER_RESET }
);

// Operations
export const updateUserDiscoverUsers = data => (
  { type: types.UPDATE_USER_DISCOVER_USERS, payload: data }
);

export const updateMultiUserDiscoverUsers = data => (
  { type: types.UPDATE_MULTI_USER_DISCOVER_USERS, payload: data }
);

export const setFilter = data => (
  { type: types.SET_DISCOVER_FILTER, payload: data }
);

export const setAllFilters = data => (
  { type: types.SET_DISCOVER_ALL_FILTERS, payload: data }
);

export const clearFilters = (filterToUpdate, mobile) => (
  { type: types.CLEAR_DISCOVER_FILTERS, payload: { filterToUpdate, mobile } }
);

export const setDiscoverColumns = data => (
  { type: types.SET_DISCOVER_COLUMNS, payload: data }
);

export const discoverSetPage = data => (
  { type: types.DISCOVER_SET_PAGE, payload: data }
);

// Get Analytics Links Tags
export const getDiscoverTagsRequest = data => (
  { type: types.GET_DISCOVER_TAGS_REQUEST, payload: data }
);

export const getDiscoverTagsDone = data => (
  { type: types.GET_DISCOVER_TAGS_DONE, payload: data }
);

export const getDiscoverTagsFailed = errors => (
  { type: types.GET_DISCOVER_TAGS_FAILED, payload: errors }
);

// Get Discover Users Tags Bulk
export const addDiscoverUsersTagsBulkRequest = data => (
  { type: types.ADD_DISCOVER_USERS_TAGS_BULK_REQUEST, payload: data }
);

export const addDiscoverUsersTagsBulkDone = data => (
  { type: types.ADD_DISCOVER_USERS_TAGS_BULK_DONE, payload: data }
);

export const addDiscoverUsersTagsBulkFailed = errors => (
  { type: types.ADD_DISCOVER_USERS_TAGS_BULK_FAILED, payload: errors }
);